// sdaListSelector is a functional element.
// Putting the class sda-list-selector on an element automatically adds a click handler to each <li> such that when
// clicked it adds the "selected" class to that element and emits a "select" event
import $ from 'jquery';
import {chain, forEach, pipe, prop} from 'ramda';
const MutationObserver = window.MutationObserver
    || window.WebKitMutationObserver
    || window.MozMutationObserver;

const selectItem = context => e => {
    e.stopPropagation();
    return context.val($(e.target).closest('[data-selectable]'));
};

const bindSelect = context => el => {
    $(el)
        .attr('data-selectable', '')
        .off('mouseup.select')
        .on('mouseup.select', selectItem.bind(context));
};

// getAddedNodes :: [{addedNodes: [Element]}] -> [Element]
const getAddedNodes = chain(prop('addedNodes'));

$.fn.sdaListSelector = function() {
    const that = this;

    new MutationObserver(
        pipe(
            getAddedNodes,
            forEach(bindSelect),
        ),
    ).observe(that[0], {childList: true});

    that[0].type = 'sdaListSelector';

    that.children()
        .attr('data-selectable', '')
        .on('mouseup.select', selectItem(that));

    that.attachMethod('removeChildren', () => {
        that.children().remove();
        return that;
    });

    return that;
};

$.valHooks.sdaListSelector = {
    get: el => $(el).data().val,
    set(el, val) {
        const $el = $(el);
        let finalVal = null;

        if (val && $el.has(val)) {
            if (val.data().hasOwnProperty('value')) {
                finalVal = val.data().value;
            } else if (val.data().hasOwnProperty('val')) {
                finalVal = val.data().val;
            } else {
                finalVal = val;
            }

            $el.find('.selected').removeClass('selected');
            $(val).addClass('selected');
            $el.data({val: finalVal});
            $el.trigger('change.val', finalVal);

            return $el;
        }
    },
};
